import { render, staticRenderFns } from "./GPathSkillEdit.vue?vue&type=template&id=dd9bb024&scoped=true"
import script from "./GPathSkillEdit.vue?vue&type=script&lang=js"
export * from "./GPathSkillEdit.vue?vue&type=script&lang=js"
import style0 from "./GPathSkillEdit.vue?vue&type=style&index=0&id=dd9bb024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9bb024",
  null
  
)

export default component.exports